export interface Pillar {
  num: string
  title: string
  desc: string
  full?: boolean
}

// The 7 content pillars — see Original Savage SEO Roadmap.md in the vault.
export const pillars: Pillar[] = [
  { num: '01', title: 'Food & Water Storage', desc: 'Long-term storage, preservation, rotation, and the shelf-life facts behind the claims.' },
  { num: '02', title: 'Home Hardening & Off-Grid Power', desc: "Structural resilience, backup power, heat, and keeping systems running when the grid doesn't." },
  { num: '03', title: 'Skills & Bushcraft', desc: "Navigation, fire, shelter, and hand-skills that don't need batteries or a supply chain." },
  { num: '04', title: 'Gear & Reviews', desc: 'Field-tested kit, honest teardowns, and what to skip. Utility over marketing.' },
  { num: '05', title: 'Wilderness Health & First-Aid', desc: "Practical basics for when help is hours out, within a non-clinician's honest limits." },
  { num: '06', title: 'Financial & Community Resilience', desc: 'Reserves, mutual aid, and the neighborhood networks that carry you through the long emergencies.' },
  { num: '07', title: 'Disaster-Specific Playbooks by Region', desc: 'Hurricane, wildfire, quake, ice: countdown plans mapped to where you actually live.', full: true },
]
